import IphoneSmsPreviewHeader from "./IphoneSmsPreviewHeader";
import { buildTokenReplacer } from "./templateUtils";

const SmsPreview = ({ values, merchant, previewTokens }) => {
  const replaceTokens = buildTokenReplacer(previewTokens);

  return (
    <IphoneSmsPreviewHeader merchantName={merchant?.name}>
      <div className="bg-zinc-100 rounded-3xl max-w-[90%] px-3 py-2">
        <p className="text-[13px] whitespace-pre-wrap cursor-default">
          {replaceTokens(values?.smsText)}
        </p>
        <br />
        <span className="text-xs text-blue-400">
          https://webpay.ontik.io/pay/id
        </span>
      </div>
    </IphoneSmsPreviewHeader>
  );
};

export default SmsPreview;
